import { logoStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

logoStyles.container = {
    css: css`
        width: 100%;
        padding: 10px;
        margin-top: 20px;
        border: 1px solid ${COLORS.black};
    `,
}